<script setup>
import NeedSidebar from "@/views/ecosystem/needs/need/NeedSidebar.vue";
import {useRoute} from "vue2-helpers/vue-router";
import {onMounted, provide, ref} from "vue";
import needsService from "@/services/ecosystem/needs.service";
import SuggestedStartupsTable from "@/views/ecosystem/needs/need/SuggestedStartupsTable.vue";
import SubmittedStartupsTable from "@/views/ecosystem/needs/need/SubmittedStartupsTable.vue";
import AllStartupsTable from "@/views/ecosystem/needs/need/AllStartupsTable.vue";
import NeedStartupSubmitModal from "@/components/ecosystem/NeedStartupSubmitModal.vue";
import AddStartups from "@/components/startups/import/AddStartups.vue";
import startupsService from "@/services/ecosystem/startups.service";
import useTrigger from "@/composables/useTrigger";

const route = useRoute();
const [updateStartups, setNeedUpdateStartups] = useTrigger();

const need = ref(null);
const submitModal = ref(null);
const hasStartups = ref(null);
const addStartups = ref(null);

onMounted(() => {
    getInfo();
    getStartupsNumbers();
});

async function getInfo() {
    const {data} = await needsService.getInfo(route.params.id);

    need.value = data;
}

async function getStartupsNumbers() {
    const {data} = await startupsService.getMyStartupsNumbers();

    hasStartups.value = !!data.total;
}

function onStartupsAdded() {
    getStartupsNumbers();
    setNeedUpdateStartups();
}

function submitStartup(id) {
    submitModal.value.open(id);
}

provide('need', need);
provide('updateStartups', updateStartups);
</script>

<template>
    <div v-if="need" class="dashboard-page">
        <NeedSidebar/>

        <main class="dashboard-page__main">
            <div
                v-if="hasStartups === false"
                class="dashboard-page__gradient dashboard-page__statistic-section"
            >
                <header class="dashboard-page__statistic-section__header mb-0">
                    <div>
                        <h2 class="heading2 mb-4">Add your portfolio to start matching with budgeted enterprise needs</h2>

                        <p>Review active opportunities from enterprise sponsors, see where your portfolio is already a fit, and submit the startups most likely to move into review.</p>
                    </div>

                    <button
                        class="button align-self-center"
                        @click="addStartups?.open()"
                    >
                        Add Startups
                    </button>
                </header>
            </div>

            <div v-if="need.is_escalated" class="submissions-closed">
                <b>submissions closed: </b> This need is no longer acceping startups
            </div>

            <SubmittedStartupsTable/>

            <SuggestedStartupsTable
                v-if="!need.is_escalated"
                @submitStartup="submitStartup"
            />

            <AllStartupsTable
                @submitStartup="submitStartup"
            />
        </main>

        <NeedStartupSubmitModal
            ref="submitModal"
            @submitted="setNeedUpdateStartups"
        />

        <AddStartups
            ref="addStartups"
            @startupsAdded="onStartupsAdded"
        />
    </div>
</template>

<style scoped>

</style>
